<template>
    <div>
        <div class="form-group position-relative">
            <input type="text" class="form-control" v-model="search" :placeholder="placeholderAsData" ref="input" @focus="show = true" @blur="hideList">
            <font-awesome-icon icon="chevron-circle-down" class="d-down" @click.stop="toggleList"/>
        </div>
        <div class="form-group position-relative">
            <ul class="list-group" v-if="show" id="list">
                <li class="list-group-item" v-for="li in filteredList" :key="li.id" @click.stop="selectItem(li)">
                    <label class="text-muted ml-1 align-middle">
                        <font-awesome-icon class="mm-color" icon="square" v-if="selectedItem.id == li.id" style="font-size: 1.2rem"/>
                        <font-awesome-icon class="mm-color" :icon="['far', 'square']"       v-else style="font-size: 1.2rem"/>
                        <span v-for="(name, index) in shownAttribute" :key="name">
                            {{li[name]}}
                            <template v-if="shownAttribute.length != index + 1">
                                -
                            </template>
                        </span>
                    </label>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                filteredList: this.list,
                selectedItem: this.selected,
                placeholderAsData: this.placeholder,
                search: '',
                show: false,
                hide: true,
            }
        },
        props: {
            shownAttribute: {
                type: Array,
                required: false,
                default() {
                    return ['name'];
                }
            },
            selected: {
                default() {
                    return ''
                }
            },
            list: {
                type: Array,
                required: true
            },
            placeholder: {
                type: String,
                required: true
            }
        },
        watch: {
            selected(val) {
                this.updatePlaceholder();
            },
            search(val) {
                if(val != '') {
                    this.show = true;
                }
                this.filteredList = this.list.filter(item => {
                    let check = false;
                    for (const attr of this.shownAttribute) {
                        check = check || item[attr].toLowerCase().includes(this.search.toLowerCase())
                        if(check) {
                            return check;
                        }
                    }
                    return check;
                });
            }
        },
        model: {
            prop: 'selected',
            event: 'select'
        },
        methods: {
            selectItem(item) {
                this.hide = false;
                this.hideList();
                this.$refs.input.focus();
                this.selectedItem = item;

                this.updatePlaceholder();
                this.$emit('select', this.selectedItem.id);
            },
            hideList() {
                this.hide = true;
                setTimeout(() => {
                    if(this.hide){
                        this.show = false;
                    }
                }, 400);
            },
            toggleList() {
                this.show = !this.show;

                if(this.show){
                    this.$refs.input.focus();
                }
            },
            updatePlaceholder() {
                if(this.selectedItem) {
                    this.placeholderAsData = this.selectedItem.id + ' - ' + this.selectedItem.name;
                }else {
                    this.placeholderAsData = this.placeholder;
                }
            }
        }
    }
</script>

<style scoped>
.d-down{
    position: absolute;
    top: 10px;
    right: 20px;
    cursor: pointer;
    font-size: 1.2rem;
    color: #5FA963;
    background-color: white;
}
.list-group{
    position: absolute;
    top: -20px;
    right: 0;
    left: 0;
    z-index: 10;
    max-height: 300px;
    overflow-y: auto;
}
.list-group-item{
    cursor: pointer;
    background-color: #fafafa;
}
</style>
